import React, { Component } from 'react';
import Table from '~/components/Table';

class Scoring extends Component { 
  render() {
    return (
      <div className='scoring-wrapper'>
        <h3 className='scoring-title site-border-color'>Scoring Summary</h3>
        { this.props.scoring.length > 0 ? 
          <Table 
            headers={this.props.headers[0]}
            data={this.props.scoring}
            values={this.props.headers[1]}
            navigation={this.props.scoring}
            filterTag='assist1'
            filter={this.props.Assists}
          /> : <div className='not-yet'>No goals yet.</div> }
      </div>
    )
  }
}

export default Scoring;